<template>
    <div id="funnel-dashboard" style="overflow: auto !important;" class="custom-font">
		<nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item" @click="$router.push('/dashboards')" style="cursor: pointer">Dashboards</li>
                <li class="breadcrumb-item active" aria-current="page">Originación</li>
            </ol>
        </nav>

        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <!-- FILTROS -->
                    <div class="row">
                        <div style="padding-top:2rem; padding-left: 2.5rem;" class="md-title col-sm-12 col-md-5">Funnel de ventas y tasa de conversión</div><br>	
                        <div style="padding-top:1rem; padding-left: 2.5rem;" class="md-title col-sm-12 col-md-2">
                            <ul class="centerx">
                                <li>
                                    <vs-radio color="warning" v-model.number="period" vs-value="1">Mensual</vs-radio>
                                </li>
                                <li>
                                    <vs-radio color="warning" v-model.number="period" vs-value="2">Trimestral</vs-radio>
                                </li>
                            </ul>
                            </div><br>	
                        <div class="col-sm-12 col-md-2">
                            <label for="">Mes:</label>
                                <vs-select
                                    v-model.number="month"
                                    class="w-full select-large"
                                    v-validate="'required'"
                                    name="sourceType"
                                    placeholder="Seleccione una opción"
                                    :disabled="period != 1">
                                <vs-select-item
                                    :key="index"
                                    :value="item.value"
                                    :text="item.text"
                                    v-for="(item,index) in months"
                                    class=""/>
                                </vs-select>
                        </div>
                        <div class="col-sm-12 col-md-2" style="margin-bottom: 1.5rem">
                            <label for="">Año:</label>
                                <vs-select
                                v-model.number="year"
                                class="w-full select-large"
                                v-validate="'required'"
                                name="sourceType"
                                placeholder="Seleccione una opción"
                            >
                                <vs-select-item
                                :key="index"
                                :value="item"
                                :text="item"
                                v-for="(item,index) in years"
                                class=""
                                />
                            </vs-select>
                        </div>
                        <div style="padding-top:1rem;" class="col-sm-12 col-md-1">
                            <div class="row">
                                <div class="col-6">
                                    <vs-button @click="period == 1 ? getFunnelData() : getFunnelByQuarter()" style="font-size: 1rem; margin-top: 1rem;" size="small" type="filled" color="success">Filtrar</vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- FILTROS -->

                    <!-- TABLA -->
                    <md-card>
                        <md-card-content>
                            <h4 class="custom-font mb-4">Originación</h4>
                            <div class="row">
                                <div class="col-md-3">
                                    <ul>
                                        <li><u>TP </u>= Tiempo Promedio</li>
                                        <li><u>TP1</u> = documentation_complete_date - created_at</li>
                                        <li><u>TP2</u> = preapproved - review_date</li>
                                    </ul>
                                </div>
                                <div class="col-md-3">
                                    <ul>
                                        <li><u>TP3</u> = approved_date - documentation_complete_date</li>
                                        <li><u>TP4</u> = approved_date - review_date</li>
                                        <li><u>TP5</u> = fund_date - public_date</li>
                                    </ul>
                                </div>
                                <div class="col-md-3">
                                    <ul>
                                        <li><u>TP6</u> = delivery_date - fund_date</li>
                                        <li><u>TP7</u> = rejected_date - review_date</li>
                                        <li><u>TP8</u> = fund_date - documentation_complete_date</li>

                                    </ul>
                                </div>
                                <div class="col-md-3">
                                    <ul>
                                        <li><u>TP9</u> = delivery_date - documentation_complete_date</li>
                                        <li><u>TP10</u> = created_at (TRX C230) - fund_date</li>
                                        <li><u>TP11</u> = installation_date - public_date</li>
                                    </ul>
                                </div>
                            </div>
                             <!-- TABLA FUNNEL MENSUAL -->
                            <md-card v-if="period == 1" style="padding:1rem;" title="Originación">
                                <vs-table :data="funnel" stripe noDataText="No hay datos disponibles">
                                    <template slot="thead">
                                        <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                                    </template>
                                    <template slot-scope="{data}">
                                        <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Prospecto</vs-td>
                                            <vs-td class="bold"  style="text-align:start !important;"># <br> %Sol.</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data">
                                                {{tr.data[1].data.total}} <br>
                                                {{tr.data[1].data.percentage}}%
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotal[1]}} <br>
                                                -
                                            </vs-td>
                                        </vs-tr>
                                        <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Solicitudes</vs-td>
                                            <vs-td class="bold" style="text-align:start !important;"># <br> %$ <br> $ <br> TP1</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data">
                                                {{tr.data[0].data.total}} <br>
                                                {{tr.data[0].data.percentage}}% <br>
                                                {{tr.data[0].data.billing == 0 ? "$0.00" : "$" + format_price(tr.data[0].data.billing)}} <br>
                                                {{tr.data[0].data.tp}}
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotal[0]}} <br>
                                                -<br>
                                                {{dineroTotal[0] == 0 || dineroTotal[0] == null ? "$0.00" : "$" + format_price(dineroTotal[0])}} <br>
                                                -
                                            </vs-td>
                                        </vs-tr>
                                        <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Pre-aprobados</vs-td>
                                            <vs-td class="bold" style="text-align:start !important;"># <br> %$ <br> $ <br> TP2</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data">
                                                {{tr.data[2].data.total}} <br>
                                                {{tr.data[2].data.percentage}}% <br>
                                                {{tr.data[2].data.billing == 0 ? "$0.00" : "$" + format_price(tr.data[2].data.billing)}} <br>
                                                {{tr.data[2].data.tp}}
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotal[2]}} <br>
                                                -<br>
                                                {{dineroTotal[2] == 0 || dineroTotal[2] == null ? "$0.00" : "$" + format_price(dineroTotal[2])}} <br>
                                                -
                                            </vs-td>
                                        </vs-tr>
                                        <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Aprobados</vs-td>
                                            <vs-td class="bold" style="text-align:start !important;"># <br> %$ <br> $ <br> TP3 <br> TP4</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data">
                                                {{tr.data[3].data.total}} <br>
                                                {{tr.data[3].data.percentage}}% <br>
                                                {{tr.data[3].data.billing == 0 || tr.data[3].data.billing == null ? "$0.00" : "$" + format_price(tr.data[3].data.billing)}} <br>
                                                {{tr.data[3].data.tp}} <br>
                                                {{tr.data[3].data.tpa}}
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotal[3]}} <br>
                                                -<br>
                                                {{dineroTotal[3] == 0 || dineroTotal[3] == null ? "$0.00" : "$" + format_price(dineroTotal[3])}} <br>
                                                - <br>
                                                -
                                            </vs-td>
                                        </vs-tr>
                                        <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Fondeados</vs-td>
                                            <vs-td class="bold" style="text-align:start !important;"># <br> %$ <br> $ <br> TP5 <br> TP8</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data">
                                                {{tr.data[4].data.total}} <br>
                                                {{tr.data[4].data.percentage}}% <br>
                                                {{tr.data[4].data.billing == 0 || tr.data[4].data.billing == null ? "$0.00" : "$" + format_price(tr.data[4].data.billing)}} <br>
                                                {{tr.data[4].data.tp}} <br>
                                                {{tr.data[4].data.tpa}}
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotal[4]}} <br>
                                                -<br>
                                                {{dineroTotal[4] == 0 || dineroTotal[4] == null ? "$0.00" : "$" + format_price(dineroTotal[4])}} <br>
                                                - <br>
                                                -
                                            </vs-td>
                                        </vs-tr>
                                        <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Entregados</vs-td>
                                            <vs-td class="bold" style="text-align:start !important;"># <br> %$ <br> $ <br> TP6 <br> TP9<br> TP11</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data">
                                                {{tr.data[5].data.total}} <br>
                                                {{tr.data[5].data.percentage}}% <br>
                                                {{tr.data[5].data.billing == 0 || tr.data[5].data.billing == null ? "$0.00" : "$" + format_price(tr.data[5].data.billing)}} <br>
                                                {{tr.data[5].data.tp}} <br>
                                                {{tr.data[5].data.tpa}} <br>
                                                {{tr.data[5].data.tpb}}
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotal[5]}} <br>
                                                -<br>
                                                {{dineroTotal[5] == 0 || dineroTotal[5] == null ? "$0.00" : "$" + format_price(dineroTotal[5])}} <br>
                                                - <br>
                                                - <br>
                                                -
                                            </vs-td>
                                        </vs-tr>
                                        <!-- <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Primera Mensualidad</vs-td>
                                            <vs-td class="bold" style="text-align:start !important;">TP10</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data">
                                                {{tr.data[8].data !=  null ? parseFloat(tr.data[8].data).toFixed(0) : 0}}
                                            </vs-td>
                                            <vs-td class="bold">
                                                -
                                            </vs-td>
                                        </vs-tr> -->
                                        <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Rechazados</vs-td>
                                            <vs-td class="bold" style="text-align:start !important;"># <br> %$ <br> $ <br> TP7</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data">
                                                {{tr.data[6].data.total}} <br>
                                                {{tr.data[6].data.percentage}}% <br>
                                                {{tr.data[6].data.billing == 0 || tr.data[6].data.billing == null ? "$0.00" : "$" + format_price(tr.data[6].data.billing)}} <br>
                                                {{tr.data[6].data.tp}}
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotal[6]}} <br>
                                                -<br>
                                                {{dineroTotal[6] == 0 || dineroTotal[6] == null ? "$0.00" : "$" + format_price(dineroTotal[6])}} <br>
                                                -
                                            </vs-td>
                                        </vs-tr>
                                        <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Reembolsados</vs-td>
                                            <vs-td class="bold" style="text-align:start !important;"># <br> %$ <br> $</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data">
                                                {{tr.data[7].data.total}} <br>
                                                {{tr.data[7].data.percentage}}% <br>
                                                {{tr.data[7].data.billing == 0 || tr.data[7].data.billing == null ? "$0.00" : "$" + format_price(tr.data[7].data.billing)}} <br>
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotal[7]}} <br>
                                                -<br>
                                                {{dineroTotal[7] == 0 || dineroTotal[7] == null ? "$0.00" : "$" + format_price(dineroTotal[7])}} <br>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </md-card>
                            <!-- TABLA FUNNEL MENSUAL -->

                            <!-- TABLA FUNNEL TRIMESTRAL -->
                            <md-card v-else-if="period == 2 && quarterFunnel.length != 0">
                                <vs-table :data="quarterFunnel" stripe noDataText="No hay datos disponibles">
                                    <template slot="thead">
                                        <vs-th class="bold" v-for="(col, idx) in quartersHeader" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                                    </template>
                                    <template slot-scope="{data}">
                                        <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Prospecto</vs-td>
                                            <vs-td class="bold"  style="text-align:start !important;"># <br> %Sol.</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data[0].data">
                                                {{tr[1].data.total}} <br>
                                                {{tr[1].data.percentage}}%
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotalFirstYear[1]}} <br>
                                                -
                                            </vs-td>
                                            <vs-td :key="indextr + '_1'" v-for="(tr, indextr) in data[1].data">
                                                {{tr[1].data.total}} <br>
                                                {{tr[1].data.percentage}}%
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotalSecondYear[1]}} <br>
                                                -
                                            </vs-td>
                                        </vs-tr>
                                        <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Solicitudes</vs-td>
                                            <vs-td class="bold" style="text-align:start !important;"># <br> %$ <br> $ <br> TP1</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data[0].data">
                                                {{tr[0].data.total}} <br>
                                                {{tr[0].data.percentage}}% <br>
                                                {{tr[0].data.billing != 0 ? `$${format_price(tr[0].data.billing)}` : "$0.00"}} <br>
                                                {{tr[0].data.tp}} <br>
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotalFirstYear[0]}} <br>
                                                - <br>
                                                {{dineroTotalFirstYear[0] == 0 ? "$0.00" : "$"+format_price(dineroTotalFirstYear[0])}} <br>
                                                -
                                            </vs-td>
                                            <vs-td :key="indextr + '_1'" v-for="(tr, indextr) in data[1].data">
                                                {{tr[0].data.total}} <br>
                                                {{tr[0].data.percentage}}% <br>
                                                {{tr[0].data.billing != 0 ? `$${format_price(tr[0].data.billing)}` : "$0.00"}} <br>
                                                {{tr[0].data.tp}} <br>
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotalSecondYear[0]}} <br>
                                                - <br>
                                                {{dineroTotalSecondYear[0] == 0 ? "$0.00" : `$${format_price(dineroTotalSecondYear[0])}`}} <br>
                                                -
                                            </vs-td>
                                        </vs-tr>
                                        <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Pre-aprobados</vs-td>
                                            <vs-td class="bold" style="text-align:start !important;"># <br> %$ <br> $ <br> TP2</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data[0].data">
                                                {{tr[2].data.total}} <br>
                                                {{tr[2].data.percentage}}% <br>
                                                {{tr[2].data.billing != 0 ? `$${format_price(tr[2].data.billing)}` : "$0.00"}} <br>
                                                {{tr[2].data.tp}} <br>
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotalFirstYear[2]}} <br>
                                                - <br>
                                                {{dineroTotalFirstYear[2] == 0 ? "$0.00" : "$"+format_price(dineroTotalFirstYear[2])}} <br>
                                                -
                                            </vs-td>
                                            <vs-td :key="indextr + '_1'" v-for="(tr, indextr) in data[1].data">
                                                {{tr[2].data.total}} <br>
                                                {{tr[2].data.percentage}}% <br>
                                                {{tr[2].data.billing != 0 ? `$${format_price(tr[2].data.billing)}` : "$0.00"}} <br>
                                                {{tr[2].data.tp}} <br>
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotalSecondYear[2]}} <br>
                                                - <br>
                                                {{dineroTotalSecondYear[2] == 0 ? "$0.00" : `$${format_price(dineroTotalSecondYear[2])}`}} <br>
                                                -
                                            </vs-td>
                                        </vs-tr>
                                        <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Aprobados</vs-td>
                                            <vs-td class="bold" style="text-align:start !important;"># <br> %$ <br> $ <br> TP3 <br> TP4</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data[0].data">
                                                {{tr[3].data.total}} <br>
                                                {{tr[3].data.percentage}}% <br>
                                                {{tr[3].data.billing != 0 ? `$${format_price(tr[3].data.billing)}` : "$0.00"}} <br>
                                                {{tr[3].data.tp}} <br>
                                                {{tr[3].data.tpa}} <br>
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotalFirstYear[3]}} <br>
                                                - <br>
                                                {{dineroTotalFirstYear[3] == 0 ? "$0.00" : "$"+format_price(dineroTotalFirstYear[3])}} <br>
                                                - <br>
                                                -
                                            </vs-td>
                                            <vs-td :key="indextr + '_1'" v-for="(tr, indextr) in data[1].data">
                                                {{tr[3].data.total}} <br>
                                                {{tr[3].data.percentage}}% <br>
                                                {{tr[3].data.billing != 0 ? `$${format_price(tr[3].data.billing)}` : "$0.00"}} <br>
                                                {{tr[3].data.tp}} <br>
                                                {{tr[3].data.tpa}} <br>
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotalSecondYear[3]}} <br>
                                                - <br>
                                                {{dineroTotalSecondYear[3] == 0 ? "$0.00" : `$${format_price(dineroTotalSecondYear[3])}`}} <br>
                                                - <br>
                                                -
                                            </vs-td>
                                        </vs-tr>
                                        <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Fondeados</vs-td>
                                            <vs-td class="bold" style="text-align:start !important;"># <br> %$ <br> $ <br> TP5 <br> TP8</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data[0].data">
                                                {{tr[4].data.total}} <br>
                                                {{tr[4].data.percentage}}% <br>
                                                {{tr[4].data.billing != 0 ? `$${format_price(tr[4].data.billing)}` : "$0.00"}} <br>
                                                {{tr[4].data.tp}} <br>
                                                {{tr[4].data.tpa}} 
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotalFirstYear[4]}} <br>
                                                - <br>
                                                {{dineroTotalFirstYear[4] == 0 ? "$0.00" : "$"+format_price(dineroTotalFirstYear[4])}} <br>
                                                - <br>
                                                -
                                            </vs-td>
                                            <vs-td :key="indextr + '_1'" v-for="(tr, indextr) in data[1].data">
                                                {{tr[4].data.total}} <br>
                                                {{tr[4].data.percentage}}% <br>
                                                {{tr[4].data.billing != 0 ? `$${format_price(tr[4].data.billing)}` : "$0.00"}} <br>
                                                {{tr[4].data.tp}} <br>
                                                {{tr[4].data.tpa}} 
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotalSecondYear[4]}} <br>
                                                - <br>
                                                {{dineroTotalSecondYear[4] == 0 ? "$0.00" : `$${format_price(dineroTotalSecondYear[4])}`}} <br>
                                                - <br>
                                                -
                                            </vs-td>
                                        </vs-tr>
                                        <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Entregados</vs-td>
                                            <vs-td class="bold" style="text-align:start !important;"># <br> %$ <br> $ <br> TP6 <br> TP9 <br> TP11</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data[0].data">
                                                {{tr[5].data.total}} <br>
                                                {{tr[5].data.percentage}}% <br>
                                                {{tr[5].data.billing != 0 ? `$${format_price(tr[5].data.billing)}` : "$0.00"}} <br>
                                                {{tr[5].data.tp}} <br>
                                                {{tr.data[5].data.tpa}} <br>
                                                {{tr.data[5].data.tpb}}
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotalFirstYear[5]}} <br>
                                                - <br>
                                                {{dineroTotalFirstYear[5] == 0 ? "$0.00" : "$"+format_price(dineroTotalFirstYear[5])}} <br>
                                                - <br>
                                                - <br>
                                                -
                                            </vs-td>
                                            <vs-td :key="indextr + '_1'" v-for="(tr, indextr) in data[1].data">
                                                {{tr[5].data.total}} <br>
                                                {{tr[5].data.percentage}}% <br>
                                                {{tr[5].data.billing != 0 ? `$${format_price(tr[5].data.billing)}` : "$0.00"}} <br>
                                                {{tr[5].data.tp}} <br>
                                                {{tr[5].data.tpa}} 
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotalSecondYear[5]}} <br>
                                                - <br>
                                                {{dineroTotalSecondYear[5] == 0 ? "$0.00" : `$${format_price(dineroTotalSecondYear[5])}`}} <br>
                                                - <br>
                                                -
                                            </vs-td>
                                        </vs-tr>
                                        <!-- <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Primera Mensualidad</vs-td>
                                            <vs-td class="bold" style="text-align:start !important;">TP10</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data[0].data">
                                                {{tr[8].data != null ? parseFloat(tr[8].data).toFixed(0) : 0 }} <br>
                                            </vs-td>
                                            <vs-td class="bold">
                                                -
                                            </vs-td>
                                            <vs-td :key="indextr + '_1'" v-for="(tr, indextr) in data[1].data">
                                                {{tr[8].data != null ? parseFloat(tr[8].data).toFixed(0) : 0 }} <br>
                                            </vs-td>
                                            <vs-td class="bold">
                                                -
                                            </vs-td>
                                        </vs-tr> -->
                                        <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Rechazados</vs-td>
                                            <vs-td class="bold" style="text-align:start !important;"># <br> %$ <br> $ <br> TP7</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data[0].data">
                                                {{tr[6].data.total}} <br>
                                                {{tr[6].data.percentage}}% <br>
                                                {{tr[6].data.billing != 0 ? `$${format_price(tr[6].data.billing)}` : "$0.00"}} <br>
                                                {{tr[6].data.tp}} <br>
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotalFirstYear[6]}} <br>
                                                - <br>
                                                {{dineroTotalFirstYear[6] == 0 ? "$0.00" : "$"+format_price(dineroTotalFirstYear[6])}} <br>
                                                -
                                            </vs-td>
                                            <vs-td :key="indextr + '_1'" v-for="(tr, indextr) in data[1].data">
                                                {{tr[6].data.total}} <br>
                                                {{tr[6].data.percentage}}% <br>
                                                {{tr[6].data.billing != 0 ? `$${format_price(tr[6].data.billing)}` : "$0.00"}} <br>
                                                {{tr[6].data.tp}} <br>
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotalSecondYear[6]}} <br>
                                                - <br>
                                                {{dineroTotalSecondYear[6] == 0 ? "$0.00" : `$${format_price(dineroTotalSecondYear[6])}`}} <br>
                                                -
                                            </vs-td>
                                        </vs-tr>
                                        <vs-tr>
                                            <vs-td class="bold" style="text-align:start !important;">Reembolsados</vs-td>
                                            <vs-td class="bold" style="text-align:start !important;"># <br> %$ <br> $</vs-td>
                                            <vs-td :key="indextr" v-for="(tr, indextr) in data[0].data">
                                                {{tr[7].data.total}} <br>
                                                {{tr[7].data.percentage}}% <br>
                                                {{tr[7].data.billing != 0 ? `$${format_price(tr[7].data.billing)}` : "$0.00"}} <br>
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotalFirstYear[7]}} <br>
                                                - <br>
                                                {{dineroTotalFirstYear[7] == 0 ? "$0.00" : "$"+format_price(dineroTotalFirstYear[7])}} <br>
                                            </vs-td>
                                            <vs-td :key="indextr + '_1'" v-for="(tr, indextr) in data[1].data">
                                                {{tr[7].data.total}} <br>
                                                {{tr[7].data.percentage}}% <br>
                                                {{tr[7].data.billing != 0 ? `$${format_price(tr[7].data.billing)}` : "$0.00"}} <br>
                                            </vs-td>
                                            <vs-td class="bold">
                                                {{solicitudTotalSecondYear[7]}} <br>
                                                - <br>
                                                {{dineroTotalSecondYear[7] == 0 ? "$0.00" : `$${format_price(dineroTotalSecondYear[7])}`}} <br>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </md-card>
                            <!-- TABLA FUNNEL TRIMESTRAL -->
                        </md-card-content>
                    </md-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formatHelper from '../../components/mixins/formatHelper';
	const months = [
	{ value: 1, text: "Enero" }
	,{ value: 2, text: "Febrero" }
	,{ value: 3, text: "Marzo" }
	,{ value: 4, text: "Abril" }
	,{ value: 5, text: "Mayo" }
	,{ value: 6, text: "Junio" }
	,{ value: 7, text: "Julio" }
	,{ value: 8, text: "Agosto" }
	,{ value: 9, text: "Septiembre" }
	,{ value: 10, text: "Octubre" }
	,{ value: 11, text: "Noviembre" }
	,{ value: 12, text: "Diciembre" }
];

const quartersHeader = [
    { title: "", key: "status", sortable: false},
    { title: "", key: "params", sortable: false},
];

export default {
    mixins: [formatHelper],
    data() {
        return {
            month: 0
            , months: months
            , year: 0
            , years: []
            , columns: [
                { title: "", key: "status", sortable: false }
                , { title: "", key: "values", sortable: false }
            ]
            , funnel: {}
            , isMounted: false
            , solicitudTotal: [0,0,0,0,0,0,0,0]
            , dineroTotal: [0,0,0,0,0,0,0,0]
            // , tpTotal: [0,0,0,0,0,0,0,0]
            // QUARTERS
            , period: 1
            , quartersHeader: quartersHeader
            , quarterFunnel: []
            , solicitudTotalFirstYear: [0,0,0,0,0,0,0,0]
            , dineroTotalFirstYear: [0,0,0,0,0,0,0,0]
            , solicitudTotalSecondYear: [0,0,0,0,0,0,0,0]
            , dineroTotalSecondYear: [0,0,0,0,0,0,0,0]
            // , tpTotalFirstYear: [0,0,0,0,0,0,0,0]
            // , tpTotalSecondYear: [0,0,0,0,0,0,0,0]
        }
    },
    mounted(){
        let date = new Date();
        this.year = date.getFullYear();
        this.month = date.getMonth()+1;
        let i = date.getFullYear();
        for(i; i>=2016; i--) {
            this.years.push(i);
        }
        this.getFunnelData();
        this.getFunnelByQuarter();
    },
    methods: {
        async getFunnelData() {
            // try {
                this.showLoading(true);
                let response = await axios.get(`/api/v2/projects/getFunnel?month=${this.month}&year=${this.year}`);
                let me = this;
                me.funnel = response.data.reverse();
                me.columns = [
                    { title: "", key: "status", sortable: false }
                    , { title: "", key: "values", sortable: false }
                ];
                let count = 0;
                me.funnel.forEach(column => {
                    me.columns.push({
                        title: me.setMonthShortName(column.month) + " " + column.year
                        , key: column.month + "-" + count
                        , sortable: false
                    });
                    count++;
                });
                me.columns.push({ title: "TOTAL", key: "MonthlyTotal", sortable: false});
                me.calculateTotals(me.funnel);
            // } catch(err) {
            //     console.log("Error1111");
            // }
            this.showLoading(false);
        },

        calculateTotals(funnel){
            this.solicitudTotal = [0,0,0,0,0,0,0,0];
            this.dineroTotal = [0,0,0,0,0,0,0,0];
            funnel.forEach(month => {
                month.data.forEach(data => {
                    switch(data.name){
                        case "Solicitudes":
                            this.solicitudTotal[0] += data.data.total;
                            this.dineroTotal[0] += data.data.billing;
                            break;
                        case "Prospectos":
                            this.solicitudTotal[1] += data.data.total;
                            break;
                        case "Pre-aprobados":
                            this.solicitudTotal[2] += data.data.total;
                            this.dineroTotal[2] += data.data.billing;
                            break;
                        case "Aprobados":
                            this.solicitudTotal[3] += data.data.total;
                            this.dineroTotal[3] += data.data.billing;
                            break;
                        case "Fondeados":
                            this.solicitudTotal[4] += data.data.total;
                            this.dineroTotal[4] += data.data.billing;
                            break;
                        case "Entregados":
                            this.solicitudTotal[5] += data.data.total;
                            this.dineroTotal[5] += data.data.billing;
                            break;
                        case "Rechazados":
                            this.solicitudTotal[6] += data.data.total;
                            this.dineroTotal[6] += data.data.billing;
                            break;
                        case "Reembolsados":
                            this.solicitudTotal[7] += data.data.total;
                            this.dineroTotal[7] += data.data.billing;
                            break;
                    }
                });
                // this.calculateTPTotalByMonth(month);
            });
        },
        // calculateTPTotalByMonth(d, type = 0){
        //     if(type == 0){
        //         d.data.forEach(data => {
        //             switch(data.name){
        //                 case "Solicitudes":
        //                     this.tpTotal[0] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotal[0]);
        //                     break;
        //                 case "Pre-aprobados":
        //                     this.tpTotal[2] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotal[2]);
        //                     break;
        //                 case "Aprobados":
        //                     this.tpTotal[3] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotal[3]);
        //                     this.tpTotal[1] += this.calculateTP(data.data.total, data.data.tpa, this.solicitudTotal[3]);
        //                     break;
        //                 case "Fondeados":
        //                     this.tpTotal[4] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotal[4]);
        //                     break;
        //                 case "Entregados":
        //                     this.tpTotal[5] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotal[5]);
        //                     break;
        //                 case "Rechazados":
        //                     this.tpTotal[6] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotal[6]);
        //                     break;
        //                 case "Reembolsados":
        //                     this.tpTotal[7] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotal[7]);
        //                     break;
        //             }
        //         });
        //     } else if(type == 1){
        //         d.forEach(data => {
        //             switch(data.name){
        //                 case "Solicitudes":
        //                     this.tpTotalFirstYear[0] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotalFirstYear[0]);
        //                     break;
        //                 case "Pre-aprobados":
        //                     this.tpTotalFirstYear[2] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotalFirstYear[2]);
        //                     break;
        //                 case "Aprobados":
        //                     this.tpTotalFirstYear[3] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotalFirstYear[3]);
        //                     this.tpTotalFirstYear[1] += this.calculateTP(data.data.total, data.data.tpa, this.solicitudTotalFirstYear[3]);
        //                     break;
        //                 case "Fondeados":
        //                     this.tpTotalFirstYear[4] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotalFirstYear[4]);
        //                     break;
        //                 case "Entregados":
        //                     this.tpTotalFirstYear[5] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotalFirstYear[5]);
        //                     break;
        //                 case "Rechazados":
        //                     this.tpTotalFirstYear[6] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotalFirstYear[6]);
        //                     break;
        //                 case "Reembolsados":
        //                     this.tpTotalFirstYear[7] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotalFirstYear[7]);
        //                     break;
        //             }
        //         });
        //     } else {
        //         d.forEach(data => {
        //             switch(data.name){
        //                 case "Solicitudes":
        //                     this.tpTotalSecondYear[0] += this.calculateTP(data.data.total, data.data.tp, this.tpTotalSecondYear[0]);
        //                     break;
        //                 case "Pre-aprobados":
        //                     this.tpTotalSecondYear[2] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotalSecondYear[2]);
        //                     break;
        //                 case "Aprobados":
        //                     this.tpTotalSecondYear[3] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotalSecondYear[3]);
        //                     this.tpTotalSecondYear[1] += this.calculateTP(data.data.total, data.data.tpa, this.solicitudTotalSecondYear[3]);
        //                     break;
        //                 case "Fondeados":
        //                     this.tpTotalSecondYear[4] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotalSecondYear[4]);
        //                     break;
        //                 case "Entregados":
        //                     this.tpTotalSecondYear[5] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotalSecondYear[5]);
        //                     break;
        //                 case "Rechazados":
        //                     this.tpTotalSecondYear[6] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotalSecondYear[6]);
        //                     break;
        //                 case "Reembolsados":
        //                     this.tpTotalSecondYear[7] += this.calculateTP(data.data.total, data.data.tp, this.solicitudTotalSecondYear[7]);
        //                     break;
        //             }
        //         });
        //     }
        // },
        setMonthShortName(month){
            switch(month){
                case "January":
                    return "ENE";
                case "February":
                    return "FEB";
                case "March":
                    return "MAR";
                case "April":
                    return "ABR";
                case "May":
                    return "MAY";
                case "June":
                    return "JUN";
                case "July":
                    return "JUL";
                case "August":
                    return "AGO";
                case "September":
                    return "SEPT";
                case "October":
                    return "OCT";
                case "November":
                    return "NOV";
                case "December":
                    return "DIC";
            }
        },
        async getFunnelByQuarter(){
            try {
                this.showLoading(true);
                let response = await axios.get(`/api/v2/projects/getFunnelByQuarter?year=${this.year}`);
                this.quarterFunnel = response.data;
                this.quartersHeader = [
                    { title: "", key: "status", sortable: false},
                    { title: "", key: "params", sortable: false},
                ]
                let i = 1;
                for(i; i<=10; i++){
                    if(i == 5 || i == 10){
                        this.quartersHeader.push(
                            {
                                title: "TOTAL"
                                , key: "total_q"+i
                                , sortable: false
                            }
                        );
                    } else {
                        this.quartersHeader.push(
                            {
                                title: "T" + (i > 4 ? i-5 : i) + " / " + this.quarterFunnel[ i > 4 ? 1 : 0].year
                                , key: "total_q"+i
                                , sortable: false
                            }
                        );
                    }
                }
                this.calculateQuarterTotals(this.quarterFunnel);

            } catch(err) {
                console.log("Error Trimestre");
            }
                this.showLoading(false);
        },
        calculateQuarterTotals(funnel){
            this.solicitudTotalFirstYear = [0,0,0,0,0,0,0,0];
            this.dineroTotalFirstYear = [0,0,0,0,0,0,0,0];
            this.solicitudTotalSecondYear = [0,0,0,0,0,0,0,0];
            this.dineroTotalSecondYear = [0,0,0,0,0,0,0,0];
            let count = 0;

            funnel.forEach(d => {
                d.data.forEach( quarter => {
                    quarter.forEach( data => {
                        if(count == 0){
                            switch(data.name){
                                case "Solicitudes":
                                    this.solicitudTotalFirstYear[0] += data.data.total;
                                    this.dineroTotalFirstYear[0] += data.data.billing;
                                    break;
                                case "Prospectos":
                                    this.solicitudTotalFirstYear[1] += data.data.total;
                                    break;
                                case "Pre-aprobados":
                                    this.solicitudTotalFirstYear[2] += data.data.total;
                                    this.dineroTotalFirstYear[2] += data.data.billing;
                                    break;
                                case "Aprobados":
                                    this.solicitudTotalFirstYear[3] += data.data.total;
                                    this.dineroTotalFirstYear[3] += data.data.billing;
                                    break;
                                case "Fondeados":
                                    this.solicitudTotalFirstYear[4] += data.data.total;
                                    this.dineroTotalFirstYear[4] += data.data.billing;
                                    break;
                                case "Entregados":
                                    this.solicitudTotalFirstYear[5] += data.data.total;
                                    this.dineroTotalFirstYear[5] += data.data.billing;
                                    break;
                                case "Rechazados":
                                    this.solicitudTotalFirstYear[6] += data.data.total;
                                    this.dineroTotalFirstYear[6] += data.data.billing;
                                    break;
                                case "Reembolsados":
                                    this.solicitudTotalFirstYear[7] += data.data.total;
                                    this.dineroTotalFirstYear[7] += data.data.billing;
                                    break;
                            }
                        } else {
                            switch(data.name){
                                case "Solicitudes":
                                    this.solicitudTotalSecondYear[0] += data.data.total;
                                    this.dineroTotalSecondYear[0] += data.data.billing;
                                    break;
                                case "Prospectos":
                                    this.solicitudTotalSecondYear[1] += data.data.total;
                                    break;
                                case "Pre-aprobados":
                                    this.solicitudTotalSecondYear[2] += data.data.total;
                                    this.dineroTotalSecondYear[2] += data.data.billing;
                                    break;
                                case "Aprobados":
                                    this.solicitudTotalSecondYear[3] += data.data.total;
                                    this.dineroTotalSecondYear[3] += data.data.billing;
                                    break;
                                case "Fondeados":
                                    this.solicitudTotalSecondYear[4] += data.data.total;
                                    this.dineroTotalSecondYear[4] += data.data.billing;
                                    break;
                                case "Entregados":
                                    this.solicitudTotalSecondYear[5] += data.data.total;
                                    this.dineroTotalSecondYear[5] += data.data.billing;
                                    break;
                                case "Rechazados":
                                    this.solicitudTotalSecondYear[6] += data.data.total;
                                    this.dineroTotalSecondYear[6] += data.data.billing;
                                    break;
                                case "Reembolsados":
                                    this.solicitudTotalSecondYear[7] += data.data.total;
                                    this.dineroTotalSecondYear[7] += data.data.billing;
                                    break;
                            }
                        }
                    });
                    // this.calculateTPTotalByMonth(quarter, count == 0 ? 1 : 2)
                });
                count++;
            });


        },
        calculateTP(noSolicitudes, tp, total){
            let t = parseInt(total);
            return (parseInt(noSolicitudes) / (t == 0 ? 1 : t)) * parseInt(tp);
        }
    }
}
</script>

<style lang="css">
    #content {
        overflow: auto !important;
    }
    .custom-font {
		font-family: 'Poppins', sans-serif !important;
	}

    td {
        text-align: end;
    }
</style>